import { render } from "./SubscribedAccount.vue?vue&type=template&id=2cfe8482"
import script from "./SubscribedAccount.vue?vue&type=script&lang=js"
export * from "./SubscribedAccount.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__